// ----------------------------------------------------------------------
// <copyright file="Izenda.PaginatorAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { observer } from 'mobx-react';
import { mapProps, withProps, compose } from 'recompose';
import { assignAll, pick, omit, getOr, ceil, isNil, min } from 'lodash/fp';

export default compose(
  observer,
  mapProps(props => {
    const { pageInfo, totalRecords, pageSize } = props;

    return assignAll([
      pick(['pageSize', 'pageIndex', 'totalRecords'], pageInfo),
      {
        totalPage: getOr(ceil(totalRecords / pageSize), 'totalPage', pageInfo)
      },
      omit(['pageInfo'], props)
    ]);
  }),
  withProps(props => {
    const { pageSize, pageIndex, currentPageSize, totalRecords } = props;
    const beginRecord = pageSize * (pageIndex - 1) + 1;
    const currentSize = isNil(currentPageSize) ? pageSize : currentPageSize;

    return {
      beginRecord: beginRecord,
      endRecord: min([beginRecord + currentSize - 1, totalRecords])
    };
  })
);


// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/helpers/Izenda.PaginatorAction.js